// import { createSelector, createIdSelector } from 'redux-views'

export const getSceneId = state => state.sceneId.sceneId
